import script from "./real-time-protection.vue?vue&type=script&setup=true&lang=ts"
export * from "./real-time-protection.vue?vue&type=script&setup=true&lang=ts"

import "./real-time-protection.vue?vue&type=style&index=0&id=c317f98e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c317f98e"]])

export default __exports__